// src/modules/Rules/adapters/CountriesApiAdapter.ts
import { HttpClient } from '@adapters/HttpClient';
import type { Option } from './ConditionApiAdapter';

export class CountriesApiAdapter {
  constructor(private httpClient: HttpClient) {}

  async getAll(): Promise<Option[]> {
    const raw = await this.httpClient.get<any>('/countries');
    const list = Array.isArray(raw) ? raw : (raw.data ?? []);
    return list.map((c: any) => ({
      id: String(c.id),
      name: c.name,
    }));
  }
}
